module.exports = __webpack_public_path__ + "img/ESH logo-full colour-512px-31012022-OL-03.1a3ff018.png";